import { API_URL } from './Constants';
import ApiService from './ApiService';

class SachNoiPageApi {

    static getAllData = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/sach-noi/all-data");
        } catch (error) {
        }
    };

    static getAllType = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/sach-noi/all-type");
        } catch (error) {
        }
    };

    static getListByCat = async (catId) => {
        try {
            let params = {};
            if (catId !== null) {
                params = { catId };
            }
            return await ApiService.getDataWithParams(API_URL + "/sach-noi/list-by-cat", params);
        } catch (error) {
        }
    };

    static getDataByPostId = async (postId) => {
        try {
            let params = {};
            if (postId !== null) {
                params = { postId };
            }
            return await ApiService.getDataWithParams(API_URL + "/sach-noi/chi-tiet", params);
        } catch (error) {
        }
    };

    // Danh sách track (chương) của một bộ sách
    static getTracksByParent = async (parentId) => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/sach-noi/tracks", { parentId });
        } catch (error) {
            return [];
        }
    };

     // --------------- ADMIN -----------------

    /**
     * Gắn các trường dùng chung cho create/update.
     * Luôn gửi trường text (kể cả rỗng) để BE hiểu là "xoá giá trị cũ";
     * không gửi thì BE giữ nguyên.
     */
    static appendCommonFields = (data, formData) => {
        data.append("title", formData.title ?? "");
        data.append("description", formData.description ?? "");
        data.append("seoUrl", formData.seoUrl ?? "");
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }
        data.append("parentId", formData.parentId ?? "0");
        if (formData.sort !== undefined && formData.sort !== null && formData.sort !== "") {
            data.append("sort", formData.sort);
        }
        data.append("linkYoutube", formData.linkYoutube ?? "");
        data.append("imageMp3", formData.imageMp3 ?? "");
        data.append("tacGia", formData.tacGia ?? "");
        data.append("nxb", formData.nxb ?? "");
        data.append("dich", formData.dich ?? "");
        data.append("dienDoc", formData.dienDoc ?? "");
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);

        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        if (formData.file) {
            data.append("file", formData.file);
        }
        // Link MP3 đi vào param ftpFilePath của BE. Gửi cả khi rỗng để xoá được.
        data.append("ftpFilePath", formData.linkMp3 ?? formData.ftpFilePath ?? "");
    };

    static submitPost = async (formData) => {
        const data = new FormData();
        SachNoiPageApi.appendCommonFields(data, formData);
        try {
            const response = await ApiService.postFormData(API_URL + "/sach-noi/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        const data = new FormData();
        data.append("postId", formData.postId);
        SachNoiPageApi.appendCommonFields(data, formData);
        data.append("isDeleteFile", formData.isDeleteFile);
        data.append("isDeleteImage", formData.isDeleteImage);
        try {
            const response = await ApiService.postFormData(API_URL + "/sach-noi/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static getChiTietSachNoiAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };

            console.log(params)

            return await ApiService.getDataWithParams(API_URL + "/sach-noi/admin/detail", params);
        } catch (error) {
        }
    }

    static getParentListAdmin = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/sach-noi/admin/list-parent");
        } catch (error) {
            console.error(error);
            return [];
        }
    }
}

export default SachNoiPageApi;
